export class SqlQueryExecutionStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<SqlQueryExecutionStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<SqlQueryExecutionStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqlQueryExecutionStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
